import React from 'react';
import { Box } from '@mui/material';
import { getWorkspaceTokens } from './workspaceStyles';

export const WORKSPACE_VIEW_LAYOUTS = {
  SINGLE_PANEL: 'singlePanel',
  SPLIT_PANEL: 'splitPanel',
  DASHBOARD_PANEL: 'dashboardPanel',
};

function getLayoutStyles(layout) {
  switch (layout) {
    case WORKSPACE_VIEW_LAYOUTS.SPLIT_PANEL:
    case WORKSPACE_VIEW_LAYOUTS.DASHBOARD_PANEL:
      return {
        alignItems: 'stretch',
      };
    case WORKSPACE_VIEW_LAYOUTS.SINGLE_PANEL:
    default:
      return {
        alignItems: 'center',
      };
  }
}

function AnalyticsWorkspaceView({
  children,
  enabled = true,
  layout = WORKSPACE_VIEW_LAYOUTS.SINGLE_PANEL,
  sx,
  style,
}) {
  if (!enabled) return <>{children}</>;

  return (
    <Box
      data-testid="analytics-workspace-view"
      data-layout={layout}
      style={style}
      sx={(theme) => {
        const tokens = getWorkspaceTokens(theme);
        return {
          width: '100%',
          minWidth: 0,
          minHeight: { xs: '100%', md: 0 },
          height: { xs: 'auto', md: '100%' },
          maxHeight: { xs: 'none', md: '100%' },
          flex: '1 1 0',
          display: 'flex',
          flexDirection: 'column',
          gap: tokens.gap.compact,
          overflow: { xs: 'visible', md: 'hidden' },
          ...getLayoutStyles(layout),
          ...sx,
        };
      }}
    >
      {children}
    </Box>
  );
}

export default AnalyticsWorkspaceView;
